import {state} from './state';
import {actions} from './actions'
import {mutations} from './mutations';
import {Module} from 'vuex';
import {ProfilesState} from "@share/profile/store/ProfilesState";


export const profiles: Module<ProfilesState, any> = {
    namespaced: true,
    state,
    mutations,
    actions
}